<div class="checkout">
    @if(pkg(); as pkg){
    <cart-summary [package]="pkg" [retail]="true"></cart-summary>
    }
    <div class="discount-form">
        <div>
            <div class="payment-method mb-10">
                <form id="card-form" novalidate (ngSubmit)="goNext()" [formGroup]="checkoutForm">
                    <div class="custom-fields">
                        @if(gift_mode()){
                        <div class="cloned-container">
                            <label for="fullname">From Name<span paint="warn">*</span></label>
                            <input type="text" id="fullname" formControlName="fullname" placeholder="John Doe"
                                autocomplete="given-name" />
                        </div>
                        <div class="cloned-container">
                            <label for="email">From Email<span paint="warn">*</span></label>
                            <input type="email" id="email" formControlName="email" placeholder="email@email.com"
                                autocomplete="email" />
                        </div>
                        <div class="cloned-container">
                            <label for="fullname">To Name<span paint="warn">*</span></label>
                            <input type="text" id="recipient" formControlName="recipient" placeholder="Jane Doe"
                                autocomplete="off" />
                        </div>
                        <div class="cloned-container">
                            <label for="email">To Email<span paint="warn">*</span></label>
                            <input type="email" id="recipient_email" formControlName="recipient_email"
                                placeholder="email2@email.com" autocomplete="off" />
                        </div>
                        <div class="cloned-container">
                            <label for="fullname">Message<span paint="warn">*</span></label>
                            <textarea type="text" id="message" formControlName="message" rows="3"
                                autocomplete="off"></textarea>
                        </div>
                        } @else {
                        <div class="cloned-container">
                            <label for="email">Email<span paint="warn">*</span></label>
                            <input type="email" id="email" formControlName="email" placeholder="email@email.com" />
                        </div>
                        <div class="cloned-container">
                            <label for="fullname">Name & Surname<span paint="warn">*</span></label>
                            <input type="text" id="fullname" formControlName="fullname" placeholder="John Doe" />
                        </div>
                        @if(pkg()?.prompt_start && checkoutForm.get('start')!.enabled){
                        <div class="cloned-container">
                            <label for="start">Start Date</label>
                            <input id="start" formControlName="start" matInput [matDatepicker]="picker"
                                placeholder="Pick a Date" (click)="picker?.open()" [min]="minDate" [max]="maxDate" />
                            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                            <mat-datepicker #picker></mat-datepicker>
                            <mat-hint>Set the date which your membership will start on</mat-hint>
                        </div>
                        }
                        @if(pkg()?.prompt_end && checkoutForm.get('end')!.enabled){
                        <div class="cloned-container">
                            <label for="start">Stop Date</label>
                            <input id="start" formControlName="end" matInput [matDatepicker]="picker"
                                placeholder="Pick a Date" (click)="picker?.open()" [min]="endMinDate"
                                [max]="endMaxDate" />
                            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                            <mat-datepicker #picker></mat-datepicker>
                            <mat-hint>Set the date which your membership will end on</mat-hint>
                        </div>
                        }
                        }
                    </div>
                    <mat-divider style="margin: 5px 5% 10px; width: 90%;"></mat-divider>
                    <div class="px-8 card-selection">
                        @if(pkg(); as pkg){
                            <card-input ngSkipHydration target="coupon" [package]="pkg._id" [manual]="true" (paymentComplete)="onPayment($event)"/>
                        }
                    </div>
                    <div class="terms my-20" [class.cosmetic]="loading()">
                        <mat-slide-toggle [formControl]="terms" paint="warn">I hereby accept the
                            <a [routerLink]="'/terms-and-conditions'" target="_blank">Terms & Conditions</a>
                            and <a [routerLink]="'/privacy-policy'" target="_blank">Privacy Policy</a>. I expressly
                            consent to the receipt of digital content in form of cloudigo discounts to be redeemed at
                            various outlets and I acknowledge that in so doing, I waive the
                            cooling-off period.</mat-slide-toggle>
                        <mat-error [class.transparent]="terms.valid || terms.untouched">Please accept the terms and
                            conditions to proceed.</mat-error>
                    </div>
                    <div class="card-form-footer">
                        <button mat-flat-button class="submit-button premium-horizontal" type="submit"
                            [disabled]="loading()">
                            @if(!loading()){
                            <h3 class="m-0">PAY NOW</h3>
                            } @else {
                            <mat-icon class="rotating" style="margin-top: -1px;">autorenew</mat-icon>
                            }
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>